import { render, staticRenderFns } from "./GrpInsAssignmentEdit.vue?vue&type=template&id=5987ab49"
import script from "./GrpInsAssignmentEdit.vue?vue&type=script&lang=js"
export * from "./GrpInsAssignmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports